export const FontAwesomeIcons = [
  { name: 'address-book', label: 'Livro de Endereços', type: 'fas' },
  { name: 'address-card', label: 'Cartão de Endereço', type: 'fas' },
  { name: 'angry', label: 'Zangado', type: 'fas' },
  { name: 'arrow-alt-circle-down', label: 'Seta Circular para Baixo', type: 'far' },
  { name: 'arrow-alt-circle-left', label: 'Seta Circular para a Esquerda', type: 'far' },
  { name: 'arrow-alt-circle-right', label: 'Seta Circular para a Direita', type: 'far' },
  { name: 'arrow-alt-circle-up', label: 'Seta Circular para Cima', type: 'far' },
  { name: 'bell', label: 'Sino', type: 'fas' },
  { name: 'bell-slash', label: 'Sino Silenciado', type: 'fas' },
  { name: 'bookmark', label: 'Marcador', type: 'fas' },
  { name: 'building', label: 'Edifício', type: 'fas' },
  { name: 'calendar', label: 'Calendário', type: 'fas' },
  { name: 'calendar-check', label: 'Calendário com Confirmação', type: 'fas' },
  { name: 'calendar-plus', label: 'Calendário com Adição', type: 'fas' },
  { name: 'calendar-times', label: 'Calendário com Remoção', type: 'fas' },
  { name: 'chart-bar', label: 'Gráfico de Barras', type: 'fas' },
  { name: 'check-circle', label: 'Círculo com Verificação', type: 'fas' },
  { name: 'check-square', label: 'Quadrado com Verificação', type: 'fas' },
  { name: 'clipboard', label: 'Área de Transferência', type: 'fas' },
  { name: 'clipboard-check', label: 'Área de Transferência com Confirmação', type: 'fas' },
  { name: 'clock', label: 'Relógio', type: 'fas' },
  { name: 'clone', label: 'Clonar', type: 'fas' },
  { name: 'cloud', label: 'Nuvem', type: 'fas' },
  { name: 'cloud-download-alt', label: 'Descarregar da Nuvem', type: 'fas' },
  { name: 'cloud-moon', label: 'Nuvem com Lua', type: 'fas' },
  { name: 'cloud-showers-heavy', label: 'Nuvem com Chuva Forte', type: 'fas' },
  { name: 'cloud-sun', label: 'Nuvem com Sol', type: 'fas' },
  { name: 'cloud-sun-rain', label: 'Nuvem com Sol e Chuva', type: 'fas' },
  { name: 'cloud-upload-alt', label: 'Carregar para a Nuvem', type: 'fas' },
  { name: 'cogs', label: 'Engrenagens', type: 'fas' },
  { name: 'coffee', label: 'Café', type: 'fas' },
  { name: 'comment', label: 'Comentário', type: 'fas' },
  { name: 'comment-alt', label: 'Comentário Alternativo', type: 'fas' },
  { name: 'comment-dots', label: 'Comentário com Pontos', type: 'fas' },
  { name: 'comments', label: 'Comentários', type: 'fas' },
  { name: 'compact-disc', label: 'Disco Compacto', type: 'fas' },
  { name: 'compass', label: 'Bússola', type: 'fas' },
  { name: 'copy', label: 'Copiar', type: 'fas' },
  { name: 'credit-card', label: 'Cartão de Crédito', type: 'fas' },
  { name: 'desktop', label: 'Computador de Secretária', type: 'fas' },
  { name: 'download', label: 'Descarregar', type: 'fas' },
  { name: 'edit', label: 'Editar', type: 'fas' },
  { name: 'ellipsis-h', label: 'Reticências Horizontal', type: 'fas' },
  { name: 'ellipsis-v', label: 'Reticências Vertical', type: 'fas' },
  { name: 'envelope', label: 'Envelope', type: 'fas' },
  { name: 'envelope-open', label: 'Envelope Aberto', type: 'fas' },
  { name: 'euro-sign', label: 'Símbolo do Euro', type: 'fas' },
  { name: 'exchange-alt', label: 'Trocar', type: 'fas' },
  { name: 'exclamation-circle', label: 'Círculo com Exclamação', type: 'fas' },
  { name: 'external-link-alt', label: 'Link Externo', type: 'fas' },
  { name: 'eye', label: 'Visualizar', type: 'fas' },
  { name: 'eye-dropper', label: 'Conta-gotas', type: 'fas' },
  { name: 'eye-slash', label: 'Visualização Desativada', type: 'fas' },
  { name: 'facebook', label: 'Facebook', type: 'fab' },
  { name: 'fast-forward', label: 'Avançar Rápido', type: 'fas' },
  { name: 'female', label: 'Feminino', type: 'fas' },
  { name: 'fighter-jet', label: 'Avião de Combate', type: 'fas' },
  { name: 'file', label: 'Ficheiro', type: 'fas' },
  { name: 'file-alt', label: 'Ficheiro de Texto', type: 'fas' },
  { name: 'file-archive', label: 'Arquivo', type: 'fas' },
  { name: 'file-audio', label: 'Ficheiro de Áudio', type: 'fas' },
  { name: 'file-code', label: 'Ficheiro de Código', type: 'fas' },
  { name: 'file-excel', label: 'Ficheiro Excel', type: 'fas' },
  { name: 'file-image', label: 'Ficheiro de Imagem', type: 'fas' },
  { name: 'file-pdf', label: 'Ficheiro PDF', type: 'fas' },
  { name: 'file-powerpoint', label: 'Ficheiro PowerPoint', type: 'fas' },
  { name: 'file-word', label: 'Ficheiro Word', type: 'fas' },
  { name: 'folder', label: 'Pasta', type: 'fas' },
  { name: 'folder-open', label: 'Pasta Aberta', type: 'fas' },
  { name: 'futbol', label: 'Futebol', type: 'fas' },
  { name: 'gem', label: 'Gema', type: 'fas' },
  { name: 'genderless', label: 'Sem Gênero', type: 'fas' },
  { name: 'gift', label: 'Presente', type: 'fas' },
  { name: 'guitar', label: 'Guitarra', type: 'fas' },
  { name: 'hamburger', label: 'Hambúrguer', type: 'fas' },
  { name: 'hdd', label: 'Disco Rígido', type: 'fas' },
  { name: 'headphones', label: 'Fones de Ouvido', type: 'fas' },
  { name: 'heart', label: 'Coração', type: 'fas' },
  { name: 'heartbeat', label: 'Batimento Cardíaco', type: 'fas' },
  { name: 'home', label: 'Casa', type: 'fas' },
  { name: 'hotel', label: 'Hotel', type: 'fas' },
  { name: 'hourglass', label: 'Ampulheta', type: 'fas' },
  { name: 'house-user', label: 'Casa de Utilizador', type: 'fas' },
  { name: 'i-cursor', label: 'Cursor', type: 'fas' },
  { name: 'id-badge', label: 'Distintivo de Identificação', type: 'fas' },
  { name: 'id-card', label: 'Cartão de Identificação', type: 'fas' },
  { name: 'id-card-alt', label: 'Cartão de Identificação Alternativo', type: 'fas' },
  { name: 'image', label: 'Imagem', type: 'fas' },
  { name: 'images', label: 'Imagens', type: 'fas' },
  { name: 'inbox', label: 'Caixa de Entrada', type: 'fas' },
  { name: 'indent', label: 'Indentar', type: 'fas' },
  { name: 'industry', label: 'Indústria', type: 'fas' },
  { name: 'infinity', label: 'Infinito', type: 'fas' },
  { name: 'info-circle', label: 'Círculo de Informação', type: 'fas' },
  { name: 'keyboard', label: 'Teclado', type: 'fas' },
  { name: 'laptop', label: 'Portátil', type: 'fas' },
  { name: 'laptop-code', label: 'Portátil com Código', type: 'fas' },
  { name: 'leaf', label: 'Folha', type: 'fas' },
  { name: 'lightbulb', label: 'Lâmpada', type: 'fas' },
  { name: 'link', label: 'Link', type: 'fas' },
  { name: 'list-alt', label: 'Lista Alternativa', type: 'fas' },
  { name: 'location-arrow', label: 'Seta de Localização', type: 'fas' },
  { name: 'lock', label: 'Fechar', type: 'fas' },
  { name: 'magic', label: 'Mágico', type: 'fas' },
  { name: 'map', label: 'Mapa', type: 'fas' },
  { name: 'map-marker', label: 'Marcador de Localização', type: 'fas' },
  { name: 'map-pin', label: 'Pin de Mapa', type: 'fas' },
  { name: 'map-signs', label: 'Placas de Mapa', type: 'fas' },
  { name: 'mars', label: 'Marte', type: 'fas' },
  { name: 'mars-double', label: 'Marte Duplo', type: 'fas' },
  { name: 'mars-stroke', label: 'Marte com Traço', type: 'fas' },
  { name: 'mars-stroke-h', label: 'Marte com Traço Horizontal', type: 'fas' },
  { name: 'mars-stroke-v', label: 'Marte com Traço Vertical', type: 'fas' },
  { name: 'medal', label: 'Medalha', type: 'fas' },
  { name: 'meh', label: 'Indiferente', type: 'fas' },
  { name: 'microchip', label: 'Microchip', type: 'fas' },
  { name: 'microphone', label: 'Microfone', type: 'fas' },
  { name: 'microphone-alt', label: 'Microfone Alternativo', type: 'fas' },
  { name: 'microscope', label: 'Microscópio', type: 'fas' },
  { name: 'minus', label: 'Menos', type: 'fas' },
  { name: 'minus-circle', label: 'Círculo com Menos', type: 'fas' },
  { name: 'minus-square', label: 'Quadrado com Menos', type: 'fas' },
  { name: 'mobile', label: 'Telemóvel', type: 'fas' },
  { name: 'mobile-alt', label: 'Telemóvel Alternativo', type: 'fas' },
  { name: 'money-bill', label: 'Nota de Dinheiro', type: 'fas' },
  { name: 'money-bill-alt', label: 'Nota de Dinheiro', type: 'fas' },
  { name: 'money-check', label: 'Cheque de Dinheiro', type: 'fas' },
  { name: 'money-check-alt', label: 'Cheque de Dinheiro Alternativo', type: 'fas' },
  { name: 'moon', label: 'Lua', type: 'fas' },
  { name: 'motorcycle', label: 'Motocicleta', type: 'fas' },
  { name: 'mouse', label: 'Rato', type: 'fas' },
  { name: 'music', label: 'Música', type: 'fas' },
  { name: 'network-wired', label: 'Rede com Fios', type: 'fas' },
  { name: 'neuter', label: 'Neutro', type: 'fas' },
  { name: 'newspaper', label: 'Jornal', type: 'fas' },
  { name: 'object-group', label: 'Grupo de Objetos', type: 'fas' },
  { name: 'object-ungroup', label: 'Desagrupar Objetos', type: 'fas' },
  { name: 'paint-brush', label: 'Pincel', type: 'fas' },
  { name: 'paint-roller', label: 'Rolo de Pintura', type: 'fas' },
  { name: 'palette', label: 'Palete', type: 'fas' },
  { name: 'paper-plane', label: 'Avião de Papel', type: 'fas' },
  { name: 'paperclip', label: 'Clipes de Papel', type: 'fas' },
  { name: 'parachute-box', label: 'Caixa de Pára-quedas', type: 'fas' },
  { name: 'pen', label: 'Caneta', type: 'fas' },
  { name: 'pen-alt', label: 'Caneta Alternativa', type: 'fas' },
  { name: 'pencil-alt', label: 'Lápis Alternativo', type: 'fas' },
  { name: 'people-carry', label: 'Pessoas Transportando', type: 'fas' },
  { name: 'percent', label: 'Porcentagem', type: 'fas' },
  { name: 'phone', label: 'Telefone', type: 'fas' },
  { name: 'phone-alt', label: 'Telefone Alternativo', type: 'fas' },
  { name: 'phone-square', label: 'Quadrado com Telefone', type: 'fas' },
  { name: 'phone-square-alt', label: 'Quadrado com Telefone Alternativo', type: 'fas' },
  { name: 'plug', label: 'Fichas', type: 'fas' },
  { name: 'plus', label: 'Adicionar', type: 'fas' },
  { name: 'plus-circle', label: 'Círculo com Adição', type: 'fas' },
  { name: 'plus-square', label: 'Quadrado com Adição', type: 'fas' },
  { name: 'poll', label: 'Enquete', type: 'fas' },
  { name: 'poll-h', label: 'Enquete Horizontal', type: 'fas' },
  { name: 'power-off', label: 'Desligar', type: 'fas' },
  { name: 'pray', label: 'Rezar', type: 'fas' },
  { name: 'prescription', label: 'Prescrição Médica', type: 'fas' },
  { name: 'prescription-bottle', label: 'Frasco de Prescrição', type: 'fas' },
  { name: 'print', label: 'Imprimir', type: 'fas' },
  { name: 'procedures', label: 'Procedimentos', type: 'fas' },
  { name: 'project-diagram', label: 'Diagrama de Projeto', type: 'fas' },
  { name: 'puzzle-piece', label: 'Peça de Quebra-Cabeça', type: 'fas' },
  { name: 'qrcode', label: 'Código QR', type: 'fas' },
  { name: 'question', label: 'Pergunta', type: 'fas' },
  { name: 'question-circle', label: 'Círculo com Pergunta', type: 'fas' },
  { name: 'quote-left', label: 'Aspas Esquerda', type: 'fas' },
  { name: 'quote-right', label: 'Aspas Direita', type: 'fas' },
  { name: 'radiation', label: 'Radiação', type: 'fas' },
  { name: 'radiation-alt', label: 'Radiação Alternativa', type: 'fas' },
  { name: 'rainbow', label: 'Arco-íris', type: 'fas' },
  { name: 'receipt', label: 'Recibo', type: 'fas' },
  { name: 'recycle', label: 'Reciclar', type: 'fas' },
  { name: 'redo', label: 'Refazer', type: 'fas' },
  { name: 'redo-alt', label: 'Refazer Alternativo', type: 'fas' },
  { name: 'registered', label: 'Registrado', type: 'fas' },
  { name: 'reply', label: 'Responder', type: 'fas' },
  { name: 'reply-all', label: 'Responder a Todos', type: 'fas' },
  { name: 'retweet', label: 'Retweetar', type: 'fas' },
  { name: 'ribbon', label: 'Fita', type: 'fas' },
  { name: 'road', label: 'Estrada', type: 'fas' },
  { name: 'rocket', label: 'Foguete', type: 'fas' },
  { name: 'rocketchat', label: 'Rocket Chat', type: 'fab' },
  { name: 'route', label: 'Rota', type: 'fas' },
  { name: 'rss', label: 'RSS', type: 'fas' },
  { name: 'ruble-sign', label: 'Símbolo do Rublo', type: 'fas' },
  { name: 'save', label: 'Guardar', type: 'fas' },
  { name: 'school', label: 'Escola', type: 'fas' },
  { name: 'screwdriver', label: 'Chave de Fenda', type: 'fas' },
  { name: 'search', label: 'Pesquisar', type: 'fas' },
  { name: 'search-minus', label: 'Pesquisar Menos', type: 'fas' },
  { name: 'search-plus', label: 'Pesquisar Mais', type: 'fas' },
  { name: 'seedling', label: 'Planta', type: 'fas' },
  { name: 'server', label: 'Servidor', type: 'fas' },
  { name: 'share', label: 'Compartilhar', type: 'fas' },
  { name: 'share-alt', label: 'Compartilhar Alternativo', type: 'fas' },
  { name: 'shield-alt', label: 'Escudo', type: 'fas' },
  { name: 'ship', label: 'Navio', type: 'fas' },
  { name: 'shopping-bag', label: 'Saco de Compras', type: 'fas' },
  { name: 'shopping-cart', label: 'Carrinho de Compras', type: 'fas' },
  { name: 'shower', label: 'Chuveiro', type: 'fas' },
  { name: 'sign-in-alt', label: 'Entrar', type: 'fas' },
  { name: 'sign-out-alt', label: 'Sair', type: 'fas' },
  { name: 'signal', label: 'Sinal', type: 'fas' },
  { name: 'sitemap', label: 'Mapa do Site', type: 'fas' },
  { name: 'skull', label: 'Caveira', type: 'fas' },
  { name: 'sliders-h', label: 'Deslizadores Horizontais', type: 'fas' },
  { name: 'smile', label: 'Sorriso', type: 'fas' },
  { name: 'snowflake', label: 'Floco de Neve', type: 'fas' },
  { name: 'sort', label: 'Ordenar', type: 'fas' },
  { name: 'sort-alpha-down', label: 'Ordenar Alfabeticamente (Crescente)', type: 'fas' },
  { name: 'sort-alpha-up', label: 'Ordenar Alfabeticamente (Decrescente)', type: 'fas' },
  { name: 'sort-amount-down', label: 'Ordenar por Quantidade (Crescente)', type: 'fas' },
  { name: 'sort-amount-up', label: 'Ordenar por Quantidade (Decrescente)', type: 'fas' },
  { name: 'sort-down', label: 'Ordenar para Baixo', type: 'fas' },
  { name: 'sort-numeric-down', label: 'Ordenar Numericamente (Crescente)', type: 'fas' },
  { name: 'sort-numeric-up', label: 'Ordenar Numericamente (Decrescente)', type: 'fas' },
  { name: 'sort-up', label: 'Ordenar para Cima', type: 'fas' },
  { name: 'space-shuttle', label: 'Shuttle Espacial', type: 'fas' },
  { name: 'spinner', label: 'Carregando', type: 'fas' },
  { name: 'square', label: 'Quadrado', type: 'fas' },
  { name: 'star', label: 'Estrela', type: 'fas' },
  { name: 'star-half', label: 'Meia Estrela', type: 'fas' },
  { name: 'star-half-alt', label: 'Meia Estrela Alternativa', type: 'fas' },
  { name: 'sticky-note', label: 'Nota Pegajosa', type: 'fas' },
  { name: 'stop', label: 'Parar', type: 'fas' },
  { name: 'stop-circle', label: 'Círculo de Parar', type: 'fas' },
  { name: 'strawberry', label: 'Morango', type: 'fas' },
  { name: 'subscript', label: 'Subscrito', type: 'fas' },
  { name: 'suitcase', label: 'Mala', type: 'fas' },
  { name: 'sun', label: 'Sol', type: 'fas' },
  { name: 'superscript', label: 'Sobrescrito', type: 'fas' },
  { name: 'sync', label: 'Sincronizar', type: 'fas' },
  { name: 'sync-alt', label: 'Sincronizar Alternativo', type: 'fas' },
  { name: 'table', label: 'Tabela', type: 'fas' },
  { name: 'tablet', label: 'Tablet', type: 'fas' },
  { name: 'tablet-alt', label: 'Tablet Alternativo', type: 'fas' },
  { name: 'tachometer-alt', label: 'Tacômetro', type: 'fas' },
  { name: 'tag', label: 'Etiqueta', type: 'fas' },
  { name: 'tags', label: 'Etiquetas', type: 'fas' },
  { name: 'tasks', label: 'Tarefas', type: 'fas' },
  { name: 'taxi', label: 'Táxi', type: 'fas' },
  { name: 'temperature-high', label: 'Temperatura Alta', type: 'fas' },
  { name: 'temperature-low', label: 'Temperatura Baixa', type: 'fas' },
  { name: 'terminal', label: 'Terminal', type: 'fas' },
  { name: 'text-height', label: 'Altura do Texto', type: 'fas' },
  { name: 'text-width', label: 'Largura do Texto', type: 'fas' },
  { name: 'th', label: 'Cabeçalho', type: 'fas' },
  { name: 'th-large', label: 'Cabeçalho Grande', type: 'fas' },
  { name: 'th-list', label: 'Lista de Cabeçalhos', type: 'fas' },
  { name: 'theater-masks', label: 'Máscaras de Teatro', type: 'fas' },
  { name: 'thumbs-down', label: 'Polegar para Baixo', type: 'fas' },
  { name: 'thumbs-up', label: 'Polegar para Cima', type: 'fas' },
  { name: 'ticket-alt', label: 'Bilhete', type: 'fas' },
  { name: 'times', label: 'X', type: 'fas' },
  { name: 'times-circle', label: 'Círculo com X', type: 'fas' },
  { name: 'tint', label: 'Tinta', type: 'fas' },
  { name: 'toggle-off', label: 'Desligado', type: 'fas' },
  { name: 'toggle-on', label: 'Ligado', type: 'fas' },
  { name: 'toilet-paper', label: 'Papel Higiênico', type: 'fas' },
  { name: 'toolbox', label: 'Caixa de Ferramentas', type: 'fas' },
  { name: 'tools', label: 'Ferramentas', type: 'fas' },
  { name: 'tooth', label: 'Dente', type: 'fas' },
  { name: 'trademark', label: 'Marca Registrada', type: 'fas' },
  { name: 'traffic-light', label: 'Semáforo', type: 'fas' },
  { name: 'train', label: 'Comboio', type: 'fas' },
  { name: 'transgender', label: 'Transgênero', type: 'fas' },
  { name: 'transgender-alt', label: 'Transgênero Alternativo', type: 'fas' },
  { name: 'trash', label: 'Lixo', type: 'fas' },
  { name: 'trash-alt', label: 'Eliminar', type: 'fas' },
  { name: 'tree', label: 'Árvore', type: 'fas' },
  { name: 'trophy', label: 'Troféu', type: 'fas' },
  { name: 'truck', label: 'Camião', type: 'fas' },
  { name: 'truck-loading', label: 'Camião Carregando', type: 'fas' },
  { name: 'truck-monster', label: 'Camião Monstro', type: 'fas' },
  { name: 'truck-moving', label: 'Camião em Movimento', type: 'fas' },
  { name: 'truck-pickup', label: 'Caminhonete', type: 'fas' },
  { name: 'tshirt', label: 'Camiseta', type: 'fas' },
  { name: 'tv', label: 'Televisão', type: 'fas' },
  { name: 'umbrella', label: 'Guarda-chuva', type: 'fas' },
  { name: 'umbrella-beach', label: 'Guarda-chuva de Praia', type: 'fas' },
  { name: 'university', label: 'Universidade', type: 'fas' },
  { name: 'unlink', label: 'Desvincular', type: 'fas' },
  { name: 'unlock', label: 'Desbloquear', type: 'fas' },
  { name: 'unlock-alt', label: 'Desbloquear Alternativo', type: 'fas' },
  { name: 'upload', label: 'Carregar', type: 'fas' },
  { name: 'user', label: 'Utilizador', type: 'fas' },
  { name: 'user-alt', label: 'Utilizador Alternativo', type: 'fas' },
  { name: 'user-alt-slash', label: 'Utilizador com Barra', type: 'fas' },
  { name: 'user-check', label: 'Verificar Utilizador', type: 'fas' },
  { name: 'user-circle', label: 'Círculo de Utilizador', type: 'fas' },
  { name: 'user-clock', label: 'Relógio do Utilizador', type: 'fas' },
  { name: 'user-cog', label: 'Configurações do Utilizador', type: 'fas' },
  { name: 'user-edit', label: 'Editar Utilizador', type: 'fas' },
  { name: 'user-friends', label: 'Amigos do Utilizador', type: 'fas' },
  { name: 'user-graduate', label: 'Utilizador Graduado', type: 'fas' },
  { name: 'user-injured', label: 'Utilizador Ferido', type: 'fas' },
  { name: 'user-lock', label: 'Utilizador com Cadeado', type: 'fas' },
  { name: 'user-md', label: 'Médico', type: 'fas' },
  { name: 'user-minus', label: 'Utilizador Menos', type: 'fas' },
  { name: 'user-plus', label: 'Adicionar Utilizador', type: 'fas' },
  { name: 'user-secret', label: 'Utilizador Secreto', type: 'fas' },
  { name: 'user-shield', label: 'Escudo de Utilizador', type: 'fas' },
  { name: 'user-slash', label: 'Utilizador com Barra', type: 'fas' },
  { name: 'user-tag', label: 'Utilizador com Etiqueta', type: 'fas' },
  { name: 'user-tie', label: 'Utilizador com Gravata', type: 'fas' },
  { name: 'user-times', label: 'Utilizador com X', type: 'fas' },
  { name: 'users', label: 'Utilizadores', type: 'fas' },
  { name: 'users-cog', label: 'Configurações de Utilizadores', type: 'fas' },
  { name: 'utensils', label: 'Utensílios', type: 'fas' },
  { name: 'vector-square', label: 'Quadrado Vetorial', type: 'fas' },
  { name: 'venus', label: 'Vénus', type: 'fas' },
  { name: 'venus-double', label: 'Vénus Duplo', type: 'fas' },
  { name: 'venus-mars', label: 'Vénus e Marte', type: 'fas' },
  { name: 'vial', label: 'Frasco', type: 'fas' },
  { name: 'vials', label: 'Frascos', type: 'fas' },
  { name: 'video', label: 'Vídeo', type: 'fas' },
  { name: 'video-slash', label: 'Vídeo com Barra', type: 'fas' },
  { name: 'vihara', label: 'Vihara', type: 'fas' },
  { name: 'volume-down', label: 'Volume para Baixo', type: 'fas' },
  { name: 'volume-mute', label: 'Volume Mudo', type: 'fas' },
  { name: 'volume-off', label: 'Volume Desligado', type: 'fas' },
  { name: 'volume-up', label: 'Volume para Cima', type: 'fas' },
  { name: 'walking', label: 'Caminhando', type: 'fas' },
  { name: 'wallet', label: 'Carteira', type: 'fas' },
  { name: 'warehouse', label: 'Armazém', type: 'fas' },
  { name: 'water', label: 'Água', type: 'fas' },
  { name: 'wave-square', label: 'Onda Quadrada', type: 'fas' },
  { name: 'weight', label: 'Peso', type: 'fas' },
  { name: 'weight-hanging', label: 'Peso Suspenso', type: 'fas' },
  { name: 'wifi', label: 'Wi-Fi', type: 'fas' },
  { name: 'wifi-slash', label: 'Wi-Fi com Barra', type: 'fas' },
  { name: 'window-close', label: 'Fechar Janela', type: 'fas' },
  { name: 'window-maximize', label: 'Maximizar Janela', type: 'fas' },
  { name: 'window-minimize', label: 'Minimizar Janela', type: 'fas' },
  { name: 'window-restore', label: 'Restaurar Janela', type: 'fas' },
  { name: 'wrench', label: 'Chave Inglesa', type: 'fas' },
  { name: 'x-ray', label: 'Raio-X', type: 'fas' },
  { name: 'yen-sign', label: 'Símbolo do Iene', type: 'fas' },
]